import Vue from 'vue'
import store from './store'
import router from './router'
import ElementUI from 'element-ui';
import { Loading } from 'element-ui';
import './theme/index.css';
import App from './App.vue'

import mainTitle from "@/components/mainTitle";
import pageTitle from "@/components/pageTitle";
Vue.config.productionTip = false

Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.component("mainTitle",mainTitle)
Vue.component("pageTitle",pageTitle)

let $loading = undefined
Vue.prototype.$showLoading = (option) =>{
  if(option){
    option = Object.assign({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    },option);
  }
  $loading = Loading.service(option);
}

Vue.prototype.$hideLoading = ()=>{
  hideLoading();
}

// 公共方法
function hideLoading(){
  if($loading){
    $loading.close();
  }
}

// 导出方法
export const loadingClose = ()=>{
  hideLoading()
}
console.log("============",process.env.NODE_ENV,"============")